<div class="h-full bg-white" [ngClass]="{ 'md:flex md:gap-16': !carousel() }">
	<div
		class="relative w-full"
		ngClass="{{ carousel() ? 'h-48' : 'md:!w-2/5 h-48 md:h-auto' }}"
	>
		<img
			class="object-cover rounded-2xl"
			alt="Accommodation Image"
			[ngSrc]="image() ?? '/assets/img/acm.jpg' | cdn"
			fill
		/>
	</div>
	<div class="flex-1" [ngClass]="{ 'mb-4': !carousel() }">
		<p class="mt-4 text-xl font-bold text-left text-gray-900">
			{{ name() }}
		</p>
		<div class="flex items-center justify-between mt-4 text-lg">
			<p class="flex items-center gap-3">
				<uc-pound-svg customStyles="h-5 w-5 text-gray-900" />
				<span>Housing Price</span>
			</p>
			<span class="font-medium">{{
				price() ? '£' + price() + ' pw' : 'Varied'
			}}</span>
		</div>
		<div class="flex items-center justify-between mt-4 text-lg">
			<p class="flex items-center gap-3">
				<uc-office-svg />
				<span>Total Rooms</span>
			</p>
			<span class="font-medium">{{
				totalRooms() ? totalRooms() + ' rooms' : 'Varied'
			}}</span>
		</div>
		@if (externalUrl()) {
			<uc-visit-website-btn
				customStyles="{{ carousel() ? 'mt-4' : 'md:max-w-max mt-6' }} w-full"
				[externalUrl]="externalUrl()"
				[product]="product()"
				componentName="Accommodation Choices"
				[uniId]="uniId()"
				buttonText="Visit Website"
				sourceType="uni"
				[source]="uniName()"
				[ugSearchOrderPosition]="ugSearchOrderPosition()"
				[uniName]="uniName()"
			/>
		}
	</div>
</div>
